<div class="cal-tab">

  <!-- ─── Silent probe in flight ─── -->
  <div class="cal-loading" *ngIf="consent === 'unknown'">
    <mat-spinner diameter="26"></mat-spinner>
  </div>

  <!-- ─── Not yet consented ─── -->
  <div class="cal-gate" *ngIf="consent === 'missing'">
    <mat-icon class="cal-gate__icon">event_busy</mat-icon>
    <p class="cal-gate__lead">
      Klidi hasn't been granted access to your Outlook calendar yet.
      This is a read-only permission — it can see your events, never change them.
    </p>
    <button mat-flat-button color="primary" [disabled]="requesting" (click)="requestConsent()">
      <mat-icon *ngIf="!requesting">event_available</mat-icon>
      <mat-spinner *ngIf="requesting" diameter="18"></mat-spinner>
      <span>{{ requesting ? 'Waiting for Microsoft…' : 'Allow calendar access' }}</span>
    </button>
  </div>

  <!-- ─── Tenant requires an administrator ─── -->
  <div class="cal-gate" *ngIf="consent === 'blocked'">
    <mat-icon class="cal-gate__icon cal-gate__icon--warn">admin_panel_settings</mat-icon>
    <p class="cal-gate__lead">
      Your organisation requires an administrator to approve calendar access.
      Ask your IT admin to grant the <strong>Calendars.Read</strong> permission to Klidi.
    </p>
  </div>

  <!-- ─── Agenda ─── -->
  <ng-container *ngIf="consent === 'granted'">
    <div class="cal-toolbar">
      <span class="cal-toolbar__title">Next 7 days</span>
      <button mat-icon-button matTooltip="Refresh" aria-label="Refresh calendar" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <div class="cal-loading" *ngIf="loading">
      <mat-spinner diameter="26"></mat-spinner>
    </div>

    <div class="cal-empty" *ngIf="!loading && days.length === 0">
      <mat-icon>event_available</mat-icon>
      <p>Nothing in your calendar for the next week.</p>
    </div>

    <div class="cal-agenda" *ngIf="!loading && days.length > 0">
      <section class="cal-day" *ngFor="let day of days; trackBy: trackByDay">
        <h4 class="cal-day__label">{{ day.label }}</h4>

        <div class="cal-event"
             *ngFor="let event of day.events; trackBy: trackByEvent"
             (click)="openInOutlook(event)">
          <div class="cal-event__time">
            <ng-container *ngIf="!event.isAllDay">{{ event.start | date:'HH:mm' }}</ng-container>
            <ng-container *ngIf="event.isAllDay">All day</ng-container>
          </div>
          <div class="cal-event__body">
            <div class="cal-event__subject">{{ event.subject }}</div>
            <div class="cal-event__meta" *ngIf="event.location || event.organizerName">
              <span *ngIf="event.location">{{ event.location }}</span>
              <span *ngIf="event.location && event.organizerName"> · </span>
              <span *ngIf="event.organizerName">{{ event.organizerName }}</span>
            </div>
          </div>
          <button mat-stroked-button
                  class="cal-event__join"
                  *ngIf="event.joinUrl"
                  matTooltip="Join the online meeting"
                  (click)="join(event, $event)">
            <mat-icon>videocam</mat-icon><span>Join</span>
          </button>
        </div>
      </section>
    </div>
  </ng-container>

  <!-- Present in every state, so the calendar is always reachable even when nothing else works -->
  <div class="cal-footer">
    <button mat-button (click)="openInOutlook()">
      <mat-icon>open_in_new</mat-icon>
      <span>Open Outlook calendar</span>
    </button>
  </div>

</div>
